import React from 'react'

import { cn } from '~/styled'

import { Flex } from '../flex/Flex'
import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'
import { SkeletonButton } from './SkeletonButton'
import { SkeletonDoughnutChart } from './SkeletonDoughnutChart'

export const SkeletonCard = ({
  numberOfRows = 3,
  withChart,
  className
}: {
  numberOfRows?: number
  withChart?: boolean
  className?: string
}) => (
  <Tile
    className={cn(
      'relative',
      'w-full',
      'flex-col',
      'items-center',
      'gap-6',
      'p-6',
      className
    )}
  >
    <div className="align-center flex w-full gap-6">
      {withChart && <SkeletonDoughnutChart />}
      <div className="flex grow flex-col gap-6">
        {Array.from({ length: numberOfRows }, (_, index) => index).map(
          (rowNumber) => (
            <SkeletonLoader
              key={rowNumber}
              className="bg-grey-200 h-10 w-full min-w-25 rounded-md"
            />
          )
        )}
      </div>
    </div>
    <SkeletonButton />
  </Tile>
)
